module.exports = __webpack_public_path__ + "img/classify_8.53109396.png";